import React, { useEffect, useState } from "react";
import { Pagination } from "../../Common";
import AddCouponModal from "./AddCouponModal";
import { FaEdit } from "react-icons/fa";

const IndividualOfferList = ({ userUid }) => {

    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(false);

    const [pageNo, setPageNO] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const [showModal, setShowModal] = useState(false);

    const [selectedCoupon, setSelectedCoupon] = useState(null);

    const [isEdit, setIsEdit] = useState(false);

    const getOffers = async () => {

        try {

            setLoading(true);

            const token = localStorage.getItem("adminAuth");

            const response = await fetch(
                `${process.env.REACT_APP_BASEURL}/admin/admin_user_coupon_list/?page=${pageNo}&page_size=${perPage}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        uid: userUid,
                    }),
                }
            );

            const result = await response.json();

            if (response.ok) {

                setOffers(result.results || []);

                setTotalItem(result.count || 0);

                setTotalPage(
                    Math.ceil((result.count || 0) / perPage)
                );

            }

        } catch (err) {

            console.log(err);

        } finally {

            setLoading(false);

        }

    };

    const updatePage = (e) => {

        const name = e.target.getAttribute("name");

        if (name === "prev") {

            if (pageNo > 1) {
                setPageNO(pageNo - 1);
            }

        }

        else if (name === "next") {

            if (pageNo < totalPage) {
                setPageNO(pageNo + 1);
            }

        }

        else {

            const page = parseInt(e.target.innerText);

            if (!isNaN(page)) {
                setPageNO(page);
            }

        }

    };

    useEffect(() => {

        if (userUid) {

            getOffers();

        }

    }, [userUid, pageNo, perPage]);

    if (loading) {

        return (

            <div className="h-full min-h-[450px] flex items-center justify-center">

                <div className="text-center">

                    <div className="w-12 h-12 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto"></div>

                    <p className="mt-4 text-gray-500">
                        Loading Offers...
                    </p>

                </div>

            </div>

        );

    }

    return (

        <>
            <div className="flex justify-between items-center mb-6">

                <div>

                    <h2 className="text-3xl font-bold text-gray-800">
                        Individual Offers
                    </h2>

                    <p className="text-gray-500 mt-1">
                        Manage personalized coupons for this customer.
                    </p>

                </div>

                <button
                    onClick={() => {

                        setSelectedCoupon(null);

                        setIsEdit(false);

                        setShowModal(true);

                    }}
                    className="bg-teal-600 hover:bg-teal-700 text-white px-5 py-2 rounded-lg"
                >
                    + Add Coupon
                </button>

            </div>
            {
                offers.length === 0 ?

                    <div className="bg-gray-50 rounded-xl border py-20 text-center">

                        <h3 className="text-xl font-semibold text-gray-600">
                            No Individual Offers
                        </h3>

                        <p className="text-gray-400 mt-2">
                            This customer doesn't have any coupon yet.
                        </p>

                    </div>

                    :

                    <div className="bg-white rounded-xl border shadow-sm overflow-hidden">
                        <div className="overflow-x-auto overflow-y-auto max-h-[600px]">

                            <table className="min-w-[1200px] w-full whitespace-nowrap border-separate border-spacing-0">

                                <thead className="bg-gray-100 border-b">

                                    <tr className="divide-x divide-gray-200">

                                        <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">
                                            Coupon
                                        </th>

                                        <th className="px-6 py-4 text-center text-sm font-semibold text-gray-600">
                                            Discount
                                        </th>

                                        <th className="px-6 py-4 text-center text-sm font-semibold text-gray-600">
                                            Min Order
                                        </th>

                                        <th className="px-6 py-4 text-center text-sm font-semibold text-gray-600">
                                            Max Discount
                                        </th>

                                        <th className="px-6 py-4 text-center text-sm font-semibold text-gray-600">
                                            Usage
                                        </th>

                                        <th className="px-6 py-4 text-center text-sm font-semibold text-gray-600">
                                            Expiry
                                        </th>

                                        <th className="px-6 py-4 text-center text-sm font-semibold text-gray-600">
                                            Status
                                        </th>

                                        <th className="px-6 py-4 text-center text-sm font-semibold text-gray-600">
                                            Action
                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {

                                        offers.map((offer) => {

                                            const isExpired =
                                                new Date(offer.valid_until) <
                                                new Date();

                                            const status = !offer.is_active
                                                ? "Inactive"
                                                : isExpired
                                                    ? "Expired"
                                                    : "Active";

                                            return (

                                                <tr
                                                    key={offer.uid}
                                                    className="border-b divide-x divide-gray-100 hover:bg-gray-50"
                                                >

                                                    <td className="px-6 py-5">

                                                        <div>

                                                            <p className="font-semibold text-gray-800">
                                                                {offer.coupon_code}
                                                            </p>

                                                            <p className="text-xs text-gray-500 mt-1">
                                                                Created :
                                                                {" "}
                                                                {new Date(
                                                                    offer.created_date
                                                                ).toLocaleDateString()}
                                                            </p>

                                                        </div>

                                                    </td>

                                                    <td className="text-center font-semibold text-teal-600">
                                                        {offer.discount_percentage}%
                                                    </td>

                                                    <td className="text-center">
                                                        ₹{offer.minimum_order_amount}
                                                    </td>

                                                    <td className="text-center">
                                                        ₹{offer.maximum_discount_amount}
                                                    </td>

                                                    <td className="text-center">
                                                        {offer.used_count} / {offer.usage_limit}
                                                    </td>

                                                    <td className="text-center">
                                                        {new Date(
                                                            offer.valid_until
                                                        ).toLocaleDateString()}
                                                    </td>

                                                    <td className="text-center">

                                                        <span
                                                            className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${status === "Active"
                                                                    ? "bg-green-100 text-green-700"
                                                                    : status === "Expired"
                                                                        ? "bg-yellow-100 text-yellow-700"
                                                                        : "bg-red-100 text-red-700"
                                                                }`}
                                                        >
                                                            {status}
                                                        </span>

                                                    </td>

                                                    <td className="text-center">

                                                        <button

                                                            onClick={() => {

                                                                setSelectedCoupon(
                                                                    offer
                                                                );

                                                                setIsEdit(true);

                                                                setShowModal(true);

                                                            }}

                                                            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium"

                                                        >

                                                            <FaEdit />

                                                            Edit

                                                        </button>

                                                    </td>

                                                </tr>

                                            );

                                        })

                                    }

                                </tbody>

                            </table>
                        </div>
                    </div>

            }
            {
                totalItem > 0 &&

                <Pagination
                    total={totalItem}
                    perPage={perPage}
                    currPage={pageNo}
                    prevPage={Math.max(1, pageNo - 2)}
                    tPage={totalPage}
                    updatePage={updatePage}
                    setCurrPage={setPageNO}
                    setPerPage={setPerPage}
                />

            }

            <AddCouponModal
                open={showModal}
                onClose={() => {
                    setShowModal(false);
                    setSelectedCoupon(null);
                    setIsEdit(false);
                }}
                userUid={userUid}
                isEdit={isEdit}
                editData={selectedCoupon}
                onSuccess={() => {
                    setShowModal(false);
                    setSelectedCoupon(null);
                    setIsEdit(false);
                    getOffers();

                }}

            />

        </>

    );

};

export default IndividualOfferList;